import { render } from "./HomeWelkom.vue?vue&type=template&id=5043eeec"
import script from "./HomeWelkom.vue?vue&type=script&lang=js"
export * from "./HomeWelkom.vue?vue&type=script&lang=js"

import "./HomeWelkom.vue?vue&type=style&index=0&id=5043eeec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__